module.exports = __webpack_public_path__ + "img/seguimiento_hist_ruteo.95bd0a8f.svg";